import React, { FC } from 'react';
import { IconButton, Menu, Box } from '@mui/material'; // Import Box
import MobileMenuLinks from './MobileMenuLinks';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close'; // Import CloseIcon
import { OutterResponsiveMenuBox, InnerResponsiveMenuBox, StyledLink } from '../style';
import whiteLogo from '../../../../media/whiteLogo.png';
import darkLogo from '../../../../media/blackLogo.png';
import '../logoStyles.css';
import { useAppDispatch, useAppSelector } from '../../../../hooks';
import { openMobileMenu, closeMobileMenu, selectMobileMenuSliceState } from './menuSlice';
import { scrollFn } from '../helper';
import { useThemeContext } from '../../../global/ThemeContext';

const MobileMenu: FC = () => {
  const dispatch = useAppDispatch();
  const menuSelector = useAppSelector(selectMobileMenuSliceState);
  const { anchorElNavSlice } = menuSelector;
  const isMenuOpen = Boolean(anchorElNavSlice);

  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleToggleNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    if (isMenuOpen) {
      dispatch(closeMobileMenu());
      setAnchorElNav(null);
    } else {
      dispatch(openMobileMenu());
      setAnchorElNav(event.currentTarget);
    }
  };

  const handleCloseNavMenu = () => {
    dispatch(closeMobileMenu());
    setAnchorElNav(null);
  };

  const { darkMode } = useThemeContext();

  return (
    <OutterResponsiveMenuBox sx={{ display: { xs: 'flex', md: 'none' } }}>
      <InnerResponsiveMenuBox>
        <IconButton
          size="large"
          aria-label="hamburger menu"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleToggleNavMenu}
          color="inherit"
          sx={{
            overflow: 'hidden',
            position: 'relative',
            width: '48px',
            height: '48px',
          }}
        >
          <Box
            sx={{
              position: 'absolute',
              transition: 'opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
              opacity: isMenuOpen ? 0 : 1,
              pointerEvents: isMenuOpen ? 'none' : 'auto',
            }}
          >
            <MenuIcon sx={{ fontSize: '3rem' }} />
          </Box>
          <Box
            sx={{
              position: 'absolute',
              transition: 'opacity 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
              opacity: isMenuOpen ? 1 : 0,
              pointerEvents: isMenuOpen ? 'auto' : 'none',
            }}
          >
            <CloseIcon sx={{ fontSize: '3rem' }} />
          </Box>
        </IconButton>
        <Menu
          id="menu-appbar"
          anchorEl={anchorElNav}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={Boolean(anchorElNavSlice)}
          onClose={handleCloseNavMenu}
          sx={{
            display: { xs: 'block', md: 'none' },
            '& .MuiPaper-root': {
              backgroundColor: darkMode ? 'rgba(18, 18, 18, 0.95)' : 'rgba(255, 255, 255, 0.95)',
              border: `1px solid ${darkMode ? '#333333' : '#EEEEEE'}`,
              backdropFilter: 'blur(8px)',
              WebkitBackdropFilter: 'blur(8px)',
              boxShadow: darkMode ? '0 8px 16px rgba(0, 0, 0, 0.3)' : '0 8px 16px rgba(0, 0, 0, 0.1)',
            },
            mt: '25px',
          }}
        >
          <MobileMenuLinks />
        </Menu>
        <StyledLink to="/" onClick={() => scrollFn('top')} style={{ flexGrow: 1, textAlign: 'right' }}>
          <img alt="urban_equestrian" src={darkMode ? whiteLogo : darkLogo} className="whiteLogoStylesMobile" />
        </StyledLink>
      </InnerResponsiveMenuBox>
    </OutterResponsiveMenuBox>
  );
};

export default MobileMenu;
